<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100 p-t-85 p-b-20">
        <div class="login100-form validate-form">
          <span>
            <center>
              <img v-bind="mainProps" src="@/assets/img/ff.png" alt="AVATAR" />
            </center>
          </span>

          <div class="wrap-input100 validate-input m-t-85 m-b-35">
            <p>Enter Email</p>
            <input v-model="email" class="input100" type="email" name="email" />
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" @click="resetPW">
              RESET PASSWORD
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainProps: { width: 200, height: 200, class: "m1" },
      email: ""
    };
  },

  methods: {
    resetPW() {
      this.$store
        .dispatch("resetPW_email", {
          email: this.email
        })
        .then(res => {
          if (res.data.response && res.data.response.code === 1) {
            window.open(`/success`, "_blank");
            this.$router.push("/login");
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.css";
@import "../../assets/css/util.css";
</style>
